document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initGaleriaProducto();
  initCantidadProducto();
  initVariantesProducto();
});

function initReveal() {
  var els = document.querySelectorAll('.tc-reveal, .tc-reveal-stagger');
  if (!els.length) return;
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('tc-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('tc-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });
  els.forEach(function (el) { observer.observe(el); });
}

function tcCambiarFoto(galeria, src) {
  var principal = galeria.querySelector('[data-tc-galeria-principal]');
  if (!principal || !src) return;
  principal.src = src;
  galeria.querySelectorAll('[data-tc-miniatura]').forEach(function (m) {
    m.classList.toggle('is-activa', m.getAttribute('data-full') === src);
  });
}

function initGaleriaProducto() {
  document.querySelectorAll('[data-tc-galeria]').forEach(function (galeria) {
    var miniaturas = galeria.querySelectorAll('[data-tc-miniatura]');
    var tira = galeria.querySelector('[data-tc-miniaturas]');

    miniaturas.forEach(function (mini) {
      mini.addEventListener('click', function () {
        tcCambiarFoto(galeria, mini.getAttribute('data-full'));
      });
    });

    galeria.querySelectorAll('[data-tc-flecha]').forEach(function (flecha) {
      flecha.addEventListener('click', function () {
        if (!tira) return;
        var dir = parseInt(flecha.getAttribute('data-tc-flecha'), 10);
        tira.scrollBy({ left: dir * tira.clientWidth * 0.8, behavior: 'smooth' });
      });
    });

    // Visor de imagen ampliada
    var principalWrap = galeria.querySelector('[data-tc-abrir-visor]');
    var pdp = galeria.closest('[data-tc-pdp]') || document;
    var visor = pdp.querySelector('[data-tc-visor]');
    if (!principalWrap || !visor) return;
    var visorImg = visor.querySelector('[data-tc-visor-img]');
    function abrir() {
      var img = galeria.querySelector('[data-tc-galeria-principal]');
      if (!img) return;
      visorImg.src = img.src;
      visor.classList.add('is-abierto');
      visor.setAttribute('aria-hidden', 'false');
    }
    function cerrar() {
      visor.classList.remove('is-abierto');
      visor.setAttribute('aria-hidden', 'true');
    }
    principalWrap.addEventListener('click', abrir);
    visor.addEventListener('click', function (e) {
      if (e.target === visor || e.target.hasAttribute('data-tc-cerrar-visor')) cerrar();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') cerrar(); });
  });
}

function initCantidadProducto() {
  document.querySelectorAll('.tc-pdp__cantidad').forEach(function (caja) {
    var input = caja.querySelector('[data-tc-cantidad-input]');
    if (!input) return;
    caja.querySelectorAll('[data-tc-cantidad]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dir = parseInt(btn.getAttribute('data-tc-cantidad'), 10);
        var actual = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, actual + dir);
      });
    });
    input.addEventListener('change', function () {
      var v = parseInt(input.value, 10);
      input.value = isNaN(v) || v < 1 ? 1 : v;
    });
  });
}

function initVariantesProducto() {
  document.querySelectorAll('[data-tc-producto-form]').forEach(function (form) {
    var dataEl = form.querySelector('[data-tc-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try {
      variantes = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    var pdp = form.closest('[data-tc-pdp]') || document;
    var galeria = pdp.querySelector('[data-tc-galeria]');
    var inputId = form.querySelector('input[name="id"]');
    var precioEl = pdp.querySelector('[data-tc-precio]');
    var tachadoEl = pdp.querySelector('[data-tc-precio-tachado]');
    var boton = form.querySelector('[data-tc-boton-comprar]');
    var botonTexto = form.querySelector('[data-tc-boton-texto]');
    var botonPrecio = form.querySelector('[data-tc-boton-precio]');
    var grupos = form.querySelectorAll('[data-tc-opcion]');

    function actualizar() {
      var seleccion = Array.prototype.map.call(grupos, function (grupo) {
        var activo = grupo.querySelector('.is-seleccionado');
        return activo ? activo.getAttribute('data-valor') : null;
      });
      var variante = variantes.find(function (v) {
        return v.options.every(function (opt, i) { return opt === seleccion[i]; });
      });
      if (!variante) return;

      if (inputId) inputId.value = variante.id;

      var oferta = variante.compare_at_price && variante.compare_at_price > variante.price;
      if (precioEl) {
        precioEl.textContent = variante.price_fmt;
        precioEl.classList.toggle('es-oferta', !!oferta);
      }
      if (tachadoEl) {
        if (oferta) {
          tachadoEl.textContent = variante.compare_fmt;
          tachadoEl.style.display = '';
        } else {
          tachadoEl.style.display = 'none';
        }
      }
      if (boton) {
        boton.disabled = !variante.available;
        if (botonTexto) {
          botonTexto.textContent = variante.available
            ? boton.getAttribute('data-texto-disponible')
            : boton.getAttribute('data-texto-agotado');
        }
        if (botonPrecio) {
          botonPrecio.textContent = '· ' + variante.price_fmt;
          botonPrecio.style.display = variante.available ? '' : 'none';
        }
      }
      if (galeria && variante.image) tcCambiarFoto(galeria, variante.image);
    }

    grupos.forEach(function (grupo) {
      var valorEl = grupo.querySelector('[data-tc-opcion-valor]');
      grupo.querySelectorAll('[data-valor]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          grupo.querySelectorAll('[data-valor]').forEach(function (b) { b.classList.remove('is-seleccionado'); });
          btn.classList.add('is-seleccionado');
          if (valorEl) valorEl.textContent = btn.getAttribute('data-valor');
          actualizar();
        });
      });
    });

    actualizar();
  });
}
